// extracted by mini-css-extract-plugin
module.exports = {"Name":"EventSignatureAcoustic_Name__2lHEp","Content":"EventSignatureAcoustic_Content__OI4gK"};